import React from "react"
import Tooltip from "@mui/material/Tooltip"
import i18n from "@/i18n"

const SLOT_HEIGHT = "30px"

const STYLES = {
  wrapper: "relative",
  fill: "w-full rounded-sm",
  conflictOverlay: "absolute top-0 left-0 pointer-events-none",
} as const

type SlotCellProps = {
  index: number
  color: string
  opacity: number
  hasMarginRight: boolean
  isFirstConflict: boolean
  conflictSpan: number
  isScrolling: boolean
  isDragging: boolean
}

const SlotCell: React.FC<SlotCellProps> = ({
  index,
  color,
  opacity,
  hasMarginRight,
  isFirstConflict,
  conflictSpan,
  isScrolling,
  isDragging,
}) => (
  <div
    data-slot-index={index}
    className={STYLES.wrapper}
    style={{ flex: "1 1 0", minWidth: "16px", marginRight: hasMarginRight ? "1px" : 0 }}
  >
    <div className={STYLES.fill} style={{ backgroundColor: color, opacity, height: SLOT_HEIGHT }} />
    {isFirstConflict && (
      <Tooltip
        title={i18n.t("app.schedule.conflict_tooltip")}
        open={!isScrolling && !isDragging}
        placement="top"
        arrow
        TransitionProps={{ timeout: 300 }}
      >
        <div
          className={STYLES.conflictOverlay}
          role="status"
          aria-label={i18n.t("app.schedule.conflict_tooltip")}
          style={{ height: SLOT_HEIGHT, width: `calc(${conflictSpan} * 100%)` }}
        />
      </Tooltip>
    )}
  </div>
)

export default SlotCell
